import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import TrustSection from '../components/TrustSection'
import ProblemSection from '../components/ProblemSection'
import PlatformArchitectureSection from '../components/PlatformArchitectureSection'
import SolutionSection from '../components/SolutionSection'
import PlatformSection from '../components/PlatformSection'
import TestimonialsSection from '../components/TestimonialsSection'
import IndustriesSection from '../components/IndustriesSection'
import CaseStudiesSection from '../components/CaseStudiesSection'
import ROICalculator from '../components/ROICalculator'
import SecuritySection from '../components/SecuritySection'
import AboutSection from '../components/AboutSection'
import PilotSection from '../components/PilotSection'
import GetStartedSection from '../components/GetStartedSection'
import CTASection from '../components/CTASection'
import Footer from '../components/Footer'

export default function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TrustSection />
        <ProblemSection />
        <PlatformArchitectureSection />
        <SolutionSection />
        <PlatformSection />
        <TestimonialsSection />
        <IndustriesSection />
        <CaseStudiesSection />
        <ROICalculator />
        <SecuritySection />
        <AboutSection />
        <PilotSection />
        <GetStartedSection />
        <CTASection />
      </main>
      <Footer />
    </>
  )
}
